import React from 'react';
import './Blog.css';

import { extractDateParts } from '../../utils'; // Utility function to extract date parts

import { FaTags } from 'react-icons/fa'; // Importing icons

import { Link } from 'react-router-dom'; // Importing Link for navigation



const Blog = ({ blog }) => {

  const { id, image, date, heading, admin, category } = blog; // Extracting data from blog
  const { day, shortMonth } = extractDateParts(date); // Extracting formatted date parts using utility function

  return (
    <div className='blog-item' key={id}>

      <img src={image} alt={heading} /> {/* Blog Image */}

      <div className='content'>

        <div className='date'><span>{day}</span> <br></br> {shortMonth}</div> {/* Blog Date */}

        {/* Blog Title with dynamic navigation */}
        <Link
          to={{
            pathname: '/Blogs/' + heading,
          }}
          state={blog}
          className='main-heading'>
          {heading}
        </Link>

        <div className='details'>

          {/* Blog Admin */}
          <h3><span>By {admin}</span></h3>

          {/* Blog Category */}
          <h3>
            <div className='icon'><FaTags /></div>
            <Link to={`/Blogs/category/${category}`}>{category}</Link> {/* Blog Category */}
          </h3>

        </div>

      </div>

    </div>
  );
};

export default Blog;